module.exports = __webpack_public_path__ + "3e5a329620518d3b5458e77c644b84ce.png";